import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { TelecomService } from '../../../services/telecom/telecom.service';
import { environment } from 'src/environments/environment';
import * as uuid from 'uuid';
import { userError } from '@angular/compiler-cli/src/transformers/util';
import { createIndexedAccessTypeNode } from 'typescript';
import { AuthService } from '../../../services/auth/auth.service';
import { TimeService } from '../../../services/time/time.service';


export class UniqueKeyValidator {
  public onlyUniqueKeys(typeData: Array<any>, currentRow): ValidatorFn {
    return (formGroup: FormGroup) => {
      const LOBControl = formGroup.get('LOB');
      const typeControl = formGroup.get('type');

      if (!LOBControl || !typeControl) {
        return null;
      }
      let key = "" + LOBControl.value + typeControl.value

      let isDuplicated = false;
      for(let i=0;i<typeData.length; i++){
        if(i != currentRow.value){
          let type = typeData[i]
          let typeKey = "" + type.LOB + type.type;
          if(key == typeKey){
            isDuplicated = true; 
          }
        }
      }
      if(isDuplicated){
        return { onlyUnique: true};
      }
      return null;
    };
  }
}

@Component({
  selector: 'app-special-messaging',
  templateUrl: './special-messaging.component.html',
  styleUrls: ['./special-messaging.component.css']
})
export class SpecialMessagingComponent implements OnInit {

  constructor(private telecomService: TelecomService, private formBuilder: FormBuilder, public auth: AuthService, private timeService:TimeService, private uniqueKeyValidator: UniqueKeyValidator) { }
  specialMessageData: Array<any> = [];
  typeData: Array<any> = []

  filteredTypeData = JSON.parse(JSON.stringify(this.typeData));
  activeSpecialMessageData = this.activeFilter();
  inactiveSpecialMessageData = this.inactiveFilter();
  filteredSpecialMessageData = JSON.parse(JSON.stringify(this.specialMessageData));
  lobList = [];
  selectedGroup = "";
  selectedQueue = "";
  allGroups = [];
  allQueues = [];
  groups = [];
  queues = [];
  groupsSelected = [];
  queuesSelected = [];
  selectedType = "";
  selectedLOB = "";
  specialMessageTypeSelected = "";
  currentUser: string = this.auth.currentUser;
  specialMsgSuperRole = environment.authRoles.specialMsgSuper;
  telecomRole = environment.authRoles.telecom;
 

  formatLOBFunction = (LOB) => { 
    let prettyLOB = this.lobList.find(lob => lob[1]== LOB);
    if( prettyLOB){
      return prettyLOB[0];
    }
    return "";
  };
  formatGroupFunction = (groupList) => {
    let prettyList = []
    groupList.forEach(groupId => {
      for(let i=0;i<this.allGroups.length;i++){
        if (this.allGroups[i].groupId.localeCompare(groupId) == 0){
          let groupName = this.allGroups[i].groupName;
          prettyList.push(groupName)
        }
      }
    });
    return prettyList.join(', ');
  }
  formatQueueFunction = (queueList) => {
    let prettyList = []
    queueList.forEach(queue => {
      prettyList.push(queue)
    });
    return prettyList.join(', ');
  }
  activatedOnly = false;
  deactivatedOnly = false;
  lambdaError = false;
  lambdaMessage = "";
  creatingRow = false;
  rowSelected = {value: -1};
  serviceNow = "";
  form = this.formBuilder.group({
    type: new FormControl('', [Validators.required, Validators.minLength(1), Validators.maxLength(30)]),
    message: new FormControl('', [Validators.required]),
    LOB: new FormControl('', [Validators.required]),
    enabled: new FormControl('', [Validators.required])
  },     {
    validators: [this.uniqueKeyValidator.onlyUniqueKeys(this.filteredTypeData, this.rowSelected)],
    updateOn: 'blur',
  });


  ngOnInit(): void {
      //lobs 
      this.telecomService.getLOBs().then((resultData:any)=>{
        console.log("get lob result: ", resultData);
        this.lobList = resultData.lobList;
      });

      //groups
      this.telecomService.getRows(environment.GroupsLambdaName).then((data: any) => {
        if(data.statusCode == 200){
          this.allGroups = data.body.Group.Item.data;
          this.groups = this.filterByLOB(this.allGroups);
        }
        else{
          console.error(data.Error)
        }
      });
      //queues
      this.telecomService.getRows(environment.QueuesLambdaName).then((data: any) => {
        if(data.statusCode == 200){
          this.allQueues = data.body.queueList;
          this.queues = this.filterByLOB(this.allQueues);
        }
        else{
          this.lambdaError = true;
          this.lambdaMessage = data.Error.message;
          console.log("Error: ", data.Error)
        }
      });
      //SpecialMessages
      this.telecomService.getRows(environment.SpecialMessageDataLambdaName).then((data: any) => {
        this.specialMessageData = JSON.parse(data.body);
        this.activeSpecialMessageData = this.activeFilter();
        this.inactiveSpecialMessageData = this.inactiveFilter();
        if(data.statusCode == 200){
          this.lambdaError = false;
          this.lambdaMessage = "";
        }
        else{
          this.lambdaError = true;
          this.lambdaMessage = data.Error.message;
          console.log("Error: ", data.Error)
        }
      });
      //SpecialMessageTypes
      this.telecomService.getRows(environment.SpecialMessageTypeDataLambdaName).then((data: any) => {
        this.typeData = JSON.parse(data.body);
        this.filteredTypeData = JSON.parse(JSON.stringify(this.typeData));
        if(data.statusCode == 200){
          this.lambdaError = false;
          this.lambdaMessage = "";
        }
        else{
          this.lambdaError = true;
          this.lambdaMessage = data.Error.message;
          console.log("Error: ", data.Error)
        }
      });
  }
  
  handleButtonEvent(e: any){
    console.log(e);
    if(e.button == "create"){
      this.creatingRow = true;
      this.rowSelected.value = -1;
      this.form.setValidators([this.uniqueKeyValidator.onlyUniqueKeys(this.filteredTypeData, this.rowSelected)]);
      this.form.updateValueAndValidity();
      return;
    }
    if(e.button == "edit"){
      for(let i=0;i<this.filteredTypeData.length;i++){
        let row = this.filteredTypeData[i]
        let rowKey = "" + row.LOB + row.type;
        let itemKey = "" + e.item.LOB + e.item.type;
        if(rowKey == itemKey){
          this.rowSelected.value = i;
          break;
        }
      }
      this.form.setValidators([this.uniqueKeyValidator.onlyUniqueKeys(this.filteredTypeData, this.rowSelected)]);
      this.form.updateValueAndValidity();
    }
    if(e.button == "confirm" || e.button == "delete"){
      if (this.creatingRow){
        let now = new Date();
        let createdDate = this.timeService.getDateTimeString(now);
        e.item["creator"] = this.currentUser;
        e.item["created"] = createdDate;
      }
      this.updateRow(e.item, this.filteredTypeData);
      let params = {
        FunctionName: environment.SpecialMessageTypeDataLambdaName,
        Payload: JSON.stringify({
          operation: 'put',
          data: this.filteredTypeData
        })
      };
      this.telecomService.callLambda(params, 'An error occurred while trying to save specialMessage type data: ').then((response: any) => {
        if(response.statusCode == 200){
          console.log(response);
        }else{
          this.lambdaError = true;
          this.lambdaMessage = response.Error;
          console.error(response); 
        }
      });
    }
    this.creatingRow = false;
  }

  handleSpecialMessageButtonEvent(e: any){
    if(e.button == "confirm" || e.button == "delete"){
      this.updateRow(e.item, this.specialMessageData);
      this.saveSpecialMessageData();
    }
  }

  updateRow(newrow, data){
    let now = new Date();
    let createdDate = this.timeService.getDateTimeString(now);
    newrow["updatedBy"] = this.currentUser;
    newrow["lastUpdated"] = createdDate;
    let row = data.findIndex((row) => row.id == newrow.id);
    data[row] = newrow;
    return newrow
  }

  addToList(item, list: Array<any>){
    list.push(item);
    return list;
  }

  removeFromList(item, list: Array<any>){
    list = list.filter(listItem => item!=listItem);
    return list;
  }

  isSelected(item, list: Array<any>){
    if(list.includes(item)){
      return true;
    }
    return false;
  }

  changeLOB(){
    this.selectedGroup = "";
    this.selectedQueue = "";
    this.groupsSelected = [];
    this.queuesSelected = [];
    this.specialMessageTypeSelected = "";
    this.groups = this.filterByLOB(this.allGroups);
    this.queues = this.filterByLOB(this.allQueues);
  }

  clearForm(){
    this.selectedType = "";
    this.selectedLOB = "";
    this.selectedGroup = "";
    this.selectedQueue = "";
    this.serviceNow = "";
    this.groupsSelected = [];
    this.queuesSelected = [];
    this.specialMessageTypeSelected = "";
    this.groups = this.filterByLOB(this.allGroups);
    this.queues = this.filterByLOB(this.allQueues);
  }

  filterByLOB(list: Array<any>){
    return list.filter(item => item.LOB == this.selectedLOB);
  }

  validateSpecialMessage(): Array<any>{
    if(!this.selectedType){
      return [false, "You must select a type."];
    }
    if(!this.selectedLOB){
      return [false, "You must select a line of business."];
    }
    if(this.groupsSelected.length == 0 && this.queuesSelected.length == 0){
      return [false, "You must select at least one queue to put the message on."];
    }
    if(!this.specialMessageTypeSelected){
      return [false, "You must select an specialMessage type."];
    }
    return [true, ""];
  }

  submitSpecialMessage(){
    let validity = this.validateSpecialMessage();
    let isValid = validity[0];
    let validMessage = validity[1];
    if(isValid){
      console.log("Validated");
      //get current time for record keeping
      let now = new Date();
      let createdDate = this.timeService.getDateTimeString(now);
      //get names from each list
      let groupNames = []
      this.groupsSelected.forEach( (group) => {
          groupNames.push(group.groupId);
      });
      let queueNames = []
      this.queuesSelected.forEach( (queue) => {
          queueNames.push(queue.queueName);
      });
      let newRow = {
        "type": this.selectedType,
        "LOB": this.selectedLOB,
        "groups": groupNames, 
        "queues": queueNames,
        "specialMessage": this.specialMessageTypeSelected,
        "active": true,
        "id": uuid.v4(),
        "serviceNow": this.serviceNow,
        "created": createdDate,
        "creator": this.currentUser,
        "lastUpdated": createdDate,
        "updatedBy": this.currentUser,
      }
      let newSpecialMessageData = JSON.parse(JSON.stringify(this.specialMessageData));
      newSpecialMessageData.push(newRow);
      this.specialMessageData = newSpecialMessageData;
      //Do the lambda thing
      this.saveSpecialMessageData();

    this.lambdaMessage = validMessage;
    this.lambdaError = !isValid;
  }
  }

  saveSpecialMessageData(){
    let params = {
      FunctionName: environment.SpecialMessageDataLambdaName,
      Payload: JSON.stringify({
        operation: 'put',
        data: this.specialMessageData
      })
    };
    this.telecomService.callLambda(params, 'An error occurred while trying to save specialMessage data: ').then((response: any) => {
      if(response.statusCode == 200){
        this.activeSpecialMessageData = this.activeFilter();
        this.inactiveSpecialMessageData = this.inactiveFilter();
        console.log(response);
      }else{
        this.lambdaError = true;
        this.lambdaMessage = response.Error.errorMessage;
        console.error(response); 
      }
    });
    this.clearForm();
  }

  activeFilter(){
    let enabled = [];
      for(let x=0; x < this.specialMessageData.length; x++){
        if(this.specialMessageData[x].hasOwnProperty('active') && this.specialMessageData[x].active == true){
          enabled.push(this.specialMessageData[x])
        }
      }
    console.log(enabled)
    return enabled;
  }

  inactiveFilter(){
    let enabled = [];
      for(let x=0; x < this.specialMessageData.length; x++){
        if(this.specialMessageData[x].hasOwnProperty('active') && this.specialMessageData[x].active == false){
          enabled.push(this.specialMessageData[x])
        }
      }
      console.log(enabled)
      return enabled;
  }

  buildCSV(){
    //create csv
    let csvContent = "data:text/csv;charset=utf-8,";
    let keys = Object.keys(this.specialMessageData[0]);
    // console.log(keys);
    csvContent += keys.join(',') + "\r\n";
    this.specialMessageData.forEach(rowObject => {
      let rowArray = []
      keys.forEach( key => {
        let rowItem = JSON.stringify(rowObject[key]);
        rowItem = rowItem.replace(/,/g, '|');
        rowArray.push(rowItem);
      });
      csvContent += rowArray.join(',') + "\r\n";
    });
    // console.log("csvContent: ", csvContent);

    //download
    let encodedUri = encodeURI(csvContent);
    let link = document.getElementById("downloadLink");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "SpecialMessageData.csv");
    link.click();
  }

  getErrorMessage(){
    if(this.form.touched){
      if(!this.form.controls.type.valid){
        return "You must specify the type of specialMessage.";
      }else if(!this.form.controls.message.valid){
        return "You must include a message.";
      }else if(!this.form.controls.LOB.valid){
        return "You must choose a Line of Business.";
      }else if(!this.form.controls.enabled.valid){
        return "You must choose whether this specialMessage type is enabled.";
      }
    }
    return "";
  }

  canEditMessages(){
    return (this.auth.memberOf.includes(this.specialMsgSuperRole)|| this.auth.memberOf.includes(this.telecomRole))
  }
}
